function validPassword (value) {
  if (value) {
    let regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_\-+=}{><.])[A-Za-z\d!@#$%^&*()_\-+=}{><.]{8,50}/;
    return String(value).replace(regex, '').length === 0;
  } else {
    return false;
  }
}

function notWhitespace (value) {
  if (value) {
    return String(value).replace(/^\s+|\s+$/g, '').length > 0;
  } else {
    return false;
  }
}

function validateEmailContact (value) {
  if (value) {
    let regex = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(.\w{2,3})+$/;
    return String(value).replace(regex, '').length === 0;
  } else {
    return false;
  }
}

function validPhoneNumber (value) {
  if (value) {
    let regex = /^(?=.*[0-9])[- +()0-9]+$/;
    return String(value).replace(regex, '').length === 0;
  } else {
    return false;
  }
}

function validPostalOrZip (value) {
  if (value) {
    let regex = /^[a-zA-Z0-9]+(?:[\w -]*[a-zA-Z0-9]+)*$/;
    return String(value).length === 0 || value.replace(regex, '').length === 0;
  } else {
    return true;
  }
}

function validLatOrLng (value) {
  if (value) {
    let regex = /^[0-9.-]*$/;
    return String(value).replace(regex, '').length === 0;
  } else {
    return false;
  }
}

export {
  validPassword,
  validPhoneNumber,
  validPostalOrZip,
  validateEmailContact,
  notWhitespace,
  validLatOrLng
};



// WEBPACK FOOTER //
// ./src/includes/validations.js